import React, { useEffect, useState } from 'react'
import ReceiveConfirmationView from './components/ReceiveConfirmationView'
import Error from 'shared/components/Error'

const ReceiveConfirmation = () => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return isError ? <Error /> : <ReceiveConfirmationView setIsError={setIsError} />
}

export default ReceiveConfirmation
